import Image from '@anm/components/image/Image';
import { FC } from 'react';

import { Label } from '../../../../StreamModalWrapper';
import { StreamRotationProps } from '../types';

import { Buttons, RotateButton } from './Wrapper';

const StreamRotation: FC<StreamRotationProps> = ({ rotate, onChange }) => (
  <Label>
    <span>Select stream placement on Instagram</span>
    <Buttons>
      <RotateButton isSelected={rotate === 'vertical'} onClick={() => onChange('vertical')}>
        <Image src={'images/streaming/maximized_rotation.svg'} alt="maximized rotation" />
        <p>Maximize</p>
      </RotateButton>
      <RotateButton isSelected={rotate === 'vertical_contain'} onClick={() => onChange('vertical_contain')}>
        <Image src={'images/streaming/fit_to_width_rotation.svg'} alt="maximized rotation" />
        <p>Fit to width</p>
      </RotateButton>
    </Buttons>
  </Label>
);

export default StreamRotation;
